export default __webpack_public_path__ + "static/media/home.3d4685ba.svg";